import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 参建单位列表
  projectDeptlistProjectCompany(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDept/pageProjectCompany',
      method: 'get',
      params: params
    })
  },
  // 全部问题列表（PC端）
  projectLeaderCheckpageAll(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderCheck/pageAll',
      method: 'get',
      params: params
    })
  },
  // 保存
  projectLeaderChecksave(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderCheck/save',
      method: 'post',
      data: data
    })
  },
  // 我创建的
  projectLeaderCheckpageCreate(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderCheck/pageCreate',
      method: 'get',
      params: params
    })
  },
  // 我处理的
  projectLeaderCheckpageDeal(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderCheck/pageDeal',
      method: 'get',
      params: params
    })
  },
  // 问题详情
  projectDangerHistorygetById(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderCheck/getById/' + id,
      method: 'get'
    })
  },
  // 问题处理
  projectDangerHistorysaveDeal(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderHistory/saveDeal',
      method: 'post',
      data: data
    })
  },
  // 问题审核
  projectDangerHistorysaveCheck(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderHistory/saveCheck',
      method: 'post',
      data: data
    })
  },
  // 删除
  projectLeaderCheckremove(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectLeaderCheck/remove/' + id,
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/leaderCheck/index.js